class CartUpsell extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';
    this.body = this.querySelector('[ref="body"]');
    const template = document.getElementById('cart-upsell-item-template');
    if (!template) return;
    this.template = template;

    const seedId = this.dataset.seedProductId;
    if (!seedId) return;

    this.loadRecommendation(seedId);
  }

  async loadRecommendation(seedId) {
    try {
      const url = `${window.Shopify?.routes?.root || '/'}recommendations/products.json?product_id=${seedId}&limit=4&intent=complementary`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      const products = Array.isArray(data?.products) ? data.products : [];
      const pick = this.pickFirstUnavailableInCart(products);
      if (!pick) return;
      this.render(pick);
      this.hidden = false;
    } catch (e) {
      // Fail silently
    }
  }

  pickFirstUnavailableInCart(products) {
    const inCart = this.getInCartProductIds();
    for (const p of products) {
      if (!p.available) continue;
      if (inCart.has(String(p.id))) continue;
      return p;
    }
    return null;
  }

  getInCartProductIds() {
    const ids = new Set();
    document.querySelectorAll('[data-cart-line-product-id]').forEach((el) => {
      const id = el.dataset.cartLineProductId;
      if (id) ids.add(String(id));
    });
    if (ids.size === 0) {
      const seed = this.dataset.seedProductId;
      if (seed) ids.add(String(seed));
    }
    return ids;
  }

  render(product) {
    const fragment = this.template.content.cloneNode(true);
    const imageLink = fragment.querySelector('[data-ref="imageLink"]');
    const img = fragment.querySelector('[data-ref="image"]');
    const titleLink = fragment.querySelector('[data-ref="titleLink"]');
    const price = fragment.querySelector('[data-ref="price"]');
    const variantId = fragment.querySelector('[data-ref="variantId"]');
    const form = fragment.querySelector('[data-ref="form"]');

    if (imageLink) imageLink.href = product.url;
    if (img) {
      const imageSrc = product.featured_image || (product.images && product.images[0]) || '';
      img.src = this.resizeImage(imageSrc, 120);
      img.alt = product.title || '';
    }
    if (titleLink) {
      titleLink.href = product.url;
      titleLink.textContent = product.title || '';
    }
    if (price) price.textContent = this.formatMoney(product.price);

    const firstAvailableVariant =
      (product.variants || []).find((v) => v.available) || (product.variants || [])[0];
    if (variantId && firstAvailableVariant) {
      variantId.value = String(firstAvailableVariant.id);
    }

    if (form) form.addEventListener('submit', this.handleAdd);

    this.body.replaceChildren(fragment);
  }

  handleAdd = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const formData = new FormData(form);
      formData.set(
        'sections',
        ['cart-drawer', 'cart-icon', 'cart-items'].join(',')
      );
      const res = await fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('add failed');
      const data = await res.json();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: data, sourceId: 'cart-upsell', data: { source: 'cart-upsell' } },
        })
      );
      this.hidden = true;
    } catch (e) {
      if (button) button.disabled = false;
    }
  };

  resizeImage(src, width) {
    if (!src) return '';
    if (src.includes('?')) {
      return `${src}&width=${width}`;
    }
    return `${src}?width=${width}`;
  }

  formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    const amount = cents / 100;
    const hasDecimals = Math.abs(amount - Math.round(amount)) > 0.0001;
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    const locale = document.documentElement.lang || 'en-US';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
      }).format(amount);
    } catch (e) {
      return `$${amount.toFixed(hasDecimals ? 2 : 0)}`;
    }
  }
}

if (!customElements.get('cart-upsell')) {
  customElements.define('cart-upsell', CartUpsell);
}
